/**
 * YouTube thumbnails, best quality first. `maxresdefault` does not exist for
 * every video and 404s as a broken image, so callers step down through this
 * list on error.
 */
export function thumbnailCandidates(videoId: string): string[] {
  if (!videoId) return [];
  return [
    `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
    `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
    `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`,
  ];
}

/** Privacy-preserving embed host, only loaded once the viewer clicks play. */
export function embedUrl(videoId: string): string {
  return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
}
